<template>
  <responsive-modal v-model="visible" size="lg">
    <div class="tool-modal-bling p-5">
      <button
        class="btn text-secondary close"
        @click="
          visible = false;
          clear();
        "
      >
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração Bling
        </strong>
      </div>
      <div class="fs-12 pt-5">
        Para integrar com o Bling, é necessário copiar a url de redirecionamento
        e colar em <br />
        <strong>Preferências > Cadastros > Cadastros de aplicativos</strong>
        <br />
        e preencher os campos obrigatórios e escolher o escopos relacionados a
        notas fiscais.
        <br />
        Após cadastrar o aplicativo Blitzpay, serão fornecidos o Client ID e
        Client Secret para serem preenchidos aqui.
        <br />
        <strong
          >Após salvar a integração, você será redirecionado para permitir que a
          Blitzpay se integre com o Bling.</strong
        >
      </div>
      <div class="d-flex align-items-center pt-5">
        <small class="text-dark">
          <a
            target="_blank"
            href="https://bling.com.br/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça o Bling
          </a>
        </small>
        <a
          class="fa-solid fa-arrow-up-right-from-square ml-3"
          target="_blank"
          href="https://bling.com.br/"
        ></a>
      </div>
      <hr />
      <small>URL de redirecionamento:</small>
      <br />
      <div class="d-flex justify-content-between">
        <button
          class="btn d-flex align-items-center justify-content-start
                small text-primary text-decoration-none px-0"
          @click="copyUrl(callback_url)"
        >
          {{ callback_url.url }}
        </button>
        <button
          class="btn btn-sm text-primary text-decoration-none"
          @click="copyUrl(callback_url)"
        >
          <i class="fa-solid fa-link"></i>
          <span class="ml-3">Copiar URL</span>
        </button>
      </div>
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <form-group
          slim
          select
          id="product-select"
          v-model="form.product_id"
          label="Nome do produto"
          placeholder="Selecionar produto..."
          :disabled="form.id != null"
          :errors="errors.product_id"
          :options="products"
        />
      </action-dispatcher>
      <!-- <form-group
          slim
          select
          id="type"
          label="Tipo da nota"
          v-model="form.type"
          placeholder="Selecione o tipo da nota ..."
          :options="[
            { id: 'product', name: 'Nota de produto' },
            { id: 'service', name: 'Nota de serviço' }
          ]"
          :errors="errors.type"
        /> -->
      <form-group
        id="client_id"
        label="Client ID"
        v-model="form.client_id"
        placeholder="Digite o client_id da integração..."
        :errors="errors.client_id"
      />
      <form-group
        id="client_secret"
        label="Client Secret"
        v-model="form.client_secret"
        placeholder="Digite o client_secret da integração..."
        :errors="errors.client_secret"
      />
      <div class="d-flex justify-content-center mt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'btn-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    },
    login: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      ...formFields(["type", "client_id", "client_secret"], {
        type: "product",
        client_id: "",
        client_secret: ""
      }),
      loading: false,
      visible: false,
      loginToken: "",
      callback_url: {}
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      } else {
        this.validateCNPJ();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["integrationList"]),
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.client_id &&
        this.validDocument &&
        this.form.client_secret !== undefined // necessário comparar com undefined porque o valor pode ser "0"
      );
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.loading = false;
      if (!this.integrationToEdit) {
        this.$store
          .dispatch("integration/getBlingHtml", this.loginToken)
          .then(response => {
            if (!response.auth_status) {
              window.open("", "_blank").document.write(response);
              this.visible = false;
              this.$emit("update-list");
            }
          });
      } else {
        this.visible = false;
        this.$emit("update-list");
      }
    },
    submit() {
      this.loading = true;
      let data = { ...this.form };
      let action = this.integrationToEdit
        ? "integration/putIntegration"
        : "integration/postIntegration";
      this.$store
        .dispatch(action, data)
        .then(object => {
          this.$message.success("Integração salva");
          this.loginToken = object.token;
          this.onSubmit();
        })
        .catch(error => {
          this.$message.error("Erro ao salvar integração");
          this.errors = error.response.data;
          this.loading = false;
        })
        .finally(() => {});
    },
    copyUrl(i) {
      navigator.clipboard.writeText(i.url);
      this.$message.success("Url copiada.");
    }
  },
  mounted() {
    this.$store.dispatch("integration/getBlingCallbackUrl").then(response => {
      this.callback_url.url = response.callback_url;
    });
  }
};
</script>
<style lang="scss" scoped>
::v-deep.fit-scroll-content {
  max-height: unset !important;
}

.tool-modal-bling {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 20px;
    }
  }
}
</style>
